/*!
 * Copyright © 2026. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatLegacyDialogRef } from '@angular/material/legacy-dialog';

/**
 * Dialog shown when a user tries to select a segment with a conflicting
 * road type (one-way vs two-way, or opposite one-way directions).
 * Informs the user that combined road type editing is not supported.
 */
@Component({
  selector: 'fm-road-type-conflict-dialog',
  templateUrl: './road-type-conflict-dialog.component.html',
  styleUrls: ['./road-type-conflict-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RoadTypeConflictDialogComponent {
  constructor(public dialogRef: MatLegacyDialogRef<RoadTypeConflictDialogComponent>) {}

  onClose(): void {
    this.dialogRef.close();
  }
}
